import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import { UserProvider } from "@/contextApi";
import setupStore from "./store";
import { initUserPilot } from "./services/userpilot";
import AppConfigProvider from "./appConfig";
import PasswordGate from "./components/Common/PasswordGate";

// SPA manages its own scroll - prevent browser from auto-restoring scroll on navigation
window.history.scrollRestoration = 'manual';

// SPA manages its own scroll - prevent browser from auto-restoring scroll on navigation
window.history.scrollRestoration = 'manual';

const root = ReactDOM.createRoot(document.getElementById("root"));
const store = setupStore();

initUserPilot(process.env.REACT_APP_USERPILOT_KEY);

root.render(
  // <React.StrictMode>
  <PasswordGate>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_SOCIAL_CLIENT_ID}>
      <BrowserRouter>
        <Provider store={store}>
          <UserProvider>
            <AppConfigProvider>
              <App />
            </AppConfigProvider>
          </UserProvider>
        </Provider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </PasswordGate>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
